import MoreProductIcon from './more_product.svg';

export { MoreProductIcon };
